export enum BASKET_ROUTES {
  MAIN = '/basket',
  LOGIN = '/basket/login',
  LOGIN_GUEST = '/basket/login/guest',
  LOGIN_EMAIL = '/basket/login/email',
  REGISTER = '/basket/register',
  RESET_PASSWORD = '/basket/reset-password',
  CHECKOUT = '/basket/payment-shipping',
  PROCESSING_ORDER = '/basket/processing-order',
  THANK_YOU_PAGE = '/basket/thank-you-page',
  CHANGE_PAYMENT_METHOD = '/basket/change-payment-method',
}

export enum SETTINGS_TABS {
  PERSONAL_DATA = 'personal-data',
  ACCESS = 'access',
  COMMUNICATION = 'communication',
}

export enum ACCOUNT_ROUTES {
  DASHBOARD = '/account/dashboard',
  ORDERS = '/account/orders',
  ORDER = '/account/order/',
  FAVORITES = '/account/favorites',
  SETTINGS = '/account/settings',
  PERSONAL_DATA = `/account/settings?tab=${SETTINGS_TABS.PERSONAL_DATA}`,
  ACCESS = `/account/settings?tab=${SETTINGS_TABS.ACCESS}`,
  COMMUNICATION = `/account/settings?tab=${SETTINGS_TABS.COMMUNICATION}`,
  VOUCHERS = '/account/vouchers',
  DELETE_ACCOUNT = `/account/settings/delete?tab=${SETTINGS_TABS.ACCESS}`,
  LOGIN = '/account/login',
  DELETE_ACCOUNT_EMAIL_INFO = '/account/delete/info',
  GIVE_VOUCHER_CONFIRM = '/account/give/confirm',
  ADD_REVIEW = '/account/voucher/add-review',
  ADD_DETAILED_REVIEW = '/account/voucher/add-detailed-review',
  REVIEW_SENT = '/account/voucher/add-detailed-review/sent',
}

export enum COMMON_ROUTES {
  NOT_FOUND = '/not-found',
  ERROR_404 = '/404',
}

export enum LOGIN_ROUTES {
  LOGIN = '/login',
  REGISTER = '/login/register',
  LOGIN_EMAIL = '/login/email',
  RESET_PASSWORD = '/login/reset-password',
  FORGOT_PASSWORD = '/login/forgot-password',
  CHANGE_PASSWORD = '/login/change-password',
  VERIFY_EMAIL = '/login/verify-email',
  NEW_PASSWORD = '/login/new-password',
  LOGIN_GUEST = '/login/guest',
}

export enum RESERVATION_ROUTES {
  RESERVATION = '/reservation',
  RESERVATION_CLAIM = '/reservation/claim',
  RESERVATION_CLAIM_FINISHED = '/reservation/claim-finished',
  RESERVATION_UPGRADE = '/reservation/upgrade',
  RESERVATION_UPGRADE_BASKET = '/reservation/upgrade/basket',
}
